<template>
    <app-layout title="Beheer">
        <template #header>
            <page-title title="Duedates" />
        </template>

        <template #pageContent>
            <div class="flex justify-between w-1/2">
                <TableSearch tableId="configuration-request-duedates" :values="requestDuedates" class="w-1/2" placeholder="Zoeken"/>

                <Modal buttonText="Toevoegen" buttonClass="add" ref="modal">
                    <h2>Duedate {{ modalTitleAction }}</h2>
                    <Form @submitted="handleSubmit" class="w-full">
                        <Input type="hidden" name="id" v-model="form.id" />
                        <Select
                            label="Type aanvraag"
                            name="request_type_id"
                            :required="true"
                            :options="requestTypeOptions"
                            :sortByLabel="false"
                            v-model="form.request_type_id"
                            :error="form.errors.request_type_id"
                        />
                        <Select
                            label="Opdracht"
                            name="assignment_type_id"
                            :required="true"
                            :options="assignmentTypeOptions"
                            :sortByLabel="false"
                            v-model="form.assignment_type_id"
                            :error="form.errors.assignment_type_id"
                        />

                        <Input type="number" label="Urgent" name="urgent" v-model="form.urgent" :error="form.errors.urgent"/>
                        <Input type="number" label="Niet urgent" name="non_urgent" v-model="form.non_urgent" :error="form.errors.non_urgent" />

                        <div class="inline-block self-end mt-4">
                            <Button text="Annuleren" buttonClass="secondary" data-modal="close" @click="form.reset()" />
                            <Button
                                :text="modalTitleAction"
                                buttonType="submit"
                                buttonClass="save"
                                class="capitalize"
                                :loading="form.processing"
                            />
                        </div>
                    </Form>
                </Modal>
            </div>

            <Table id="configuration-request-duedates" :values="requestDuedates" class="w-1/2">
                <thead>
                    <Th id="request_type.type">Type aanvraag</Th>
                    <Th id="assignment_type.name">Opdracht</th>
                    <Th id="urgent">Urgent</th>
                    <Th id="non_urgent">Niet urgent</th>
                    <Th :sort="false" class="w-[75px]"></Th>
                </thead>
                <tbody>
                <tr v-for="(requestDuedate, key) in state.sortedValues['configuration-request-duedates']" :key="key">
                    <Td>{{ requestDuedate.request_type.type }}</Td>
                    <Td>{{ requestDuedate.assignment_type.name }}</Td>
                    <Td>{{ requestDuedate.urgent }}</Td>
                    <Td>{{ requestDuedate.non_urgent }}</Td>
                    <Td>
                        <Button buttonClass="edit" size="small" title="Bewerken" @click="updateRequestDuedate(requestDuedate)" />
                        <Button buttonClass="delete" size="small" title="Verwijderen" @click="deleteRequestDuedate(requestDuedate)" />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import {onMounted, ref, watch} from "vue"
import {useForm} from "@inertiajs/inertia-vue3"
import {Inertia} from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Form,
        Input,
        Select,
    },
    props: [
        'requestDuedates',
        'requestTypes',
        'assignmentTypes',
    ],
    setup (props)
    {
    let modalTitleAction = ref('toevoegen') //of bewerken
    const modal = ref(null)
    let requestTypeOptions = {}
    let assignmentTypeOptions = {}

    props.requestTypes.forEach(function(requestType) {
        requestTypeOptions[requestType.id] = requestType.type
    })

    props.assignmentTypes.forEach(function(assignmentType) {
        assignmentTypeOptions[assignmentType.id] = assignmentType.name
    })

    const form = useForm({
        id: null,
        request_type_id: null,
        assignment_type_id: null,
        urgent: null,
        non_urgent: null,
    })

    function updateRequestDuedate(requestDuedate)
        {
            form.id = requestDuedate.id
            form.request_type_id = requestDuedate.request_type.id
            form.assignment_type_id = requestDuedate.assignment_type.id
            form.urgent = requestDuedate.urgent
            form.non_urgent = requestDuedate.non_urgent

            modalTitleAction.value = 'bewerken'
            modal.value.show = true
        }

        function deleteRequestDuedate(requestDuedate)
        {
            if (!confirm('Bent u zeker dat u dit deze duedate wil verwijderen?'))
                return

            Inertia.delete('/configuration/request_duedates/' + requestDuedate.id)
        }

        function handleSubmit()
        {
            if (modalTitleAction.value == 'toevoegen')
            {
                //Store
                form.post('/configuration/request_duedates', {
                    onSuccess: () => {
                        modal.value.show = false
                        form.clearErrors()
                        form.reset()
                    },
                })
            } else {
                //Update
                form.put('/configuration/request_duedates/' + form.id, {
                    onSuccess: () => {
                        modal.value.show = false
                        form.clearErrors()
                        form.reset()
                    },
                })
            }
        }

        onMounted(() => {
            //Check if modal gets closed
            watch(() => modal.value.show, (modalShow, prevModalShow) => {
                if (!modalShow) {
                    //Reset to default values
                    setTimeout(function() {
                            modalTitleAction.value = 'toevoegen'
                            form.clearErrors()
                            form.reset()
                        },
                        500
                    );
                }
            })
        })

        return {
            state: store.state,
            ...store,
            form,
            handleSubmit,
            modal,
            modalTitleAction,
            updateRequestDuedate,
            deleteRequestDuedate,
            requestTypeOptions,
            assignmentTypeOptions,
        }
    },
}

</script>
